import {
    getSubject,
    getSize,
    getItemIds,
    getRowClientItemId,
    getHasIRM,
} from '../selectors/mailRowDataPropertyGetter';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import loc from 'owa-localize';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import getSelectedTableView from './getSelectedTableView';
import type { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import isMailListConversationView from './isMailListConversationView';
import type { MailboxInfo } from 'owa-client-types';
import getListViewStore from '../store/Store';
import { getUniqueMailboxInfoOrDefault } from './unifiedInbox/getUniqueMailboxInfoOrDefault';

export default function getMailListRowDragData(
    tableViewId?: string,
    isCopy?: boolean
): MailListRowDragData | undefined {
    // Also rename this to getMailListRowDragData. May be get this information from the mailRowData getter api
    const tableView = tableViewId
        ? (getListViewStore().tableViews.get(tableViewId) ?? getSelectedTableView())
        : getSelectedTableView();
    if (!tableView) {
        return undefined;
    }

    // In case of no selected rows, return undefined
    // For single selection mode, we will return DraggableItemTypes.MailListRow
    // but from owa-mail-list-view/src/components/MailListItemContainer.tsx
    // since it is the place where we have the reference of the rowKey being dragged.
    const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
    if (selectedRowKeys.length === 0) {
        return undefined;
    }
    const latestItemIds: string[] = [];
    const subjects: string[] = [];
    const sizes: number[] = [];
    const mailboxInfos: MailboxInfo[] = [];
    const haveIRM: boolean[] = [];
    const itemType = isMailListConversationView(tableView)
        ? DraggableItemTypes.MultiMailListConversationRows
        : DraggableItemTypes.MultiMailListMessageRows;

    for (const rowKey of selectedRowKeys) {
        const subject = getSubject(rowKey, tableView);
        subjects.push(subject ?? loc(noSubject));

        const size = getSize(rowKey, tableView);
        sizes.push(size ?? 0);

        const itemIds = getItemIds(rowKey, tableView);
        if (itemIds) {
            latestItemIds.push(itemIds[0]);
        }

        const mailboxInfo = getRowClientItemId(rowKey, tableView)?.mailboxInfo;
        mailboxInfos.push(mailboxInfo ?? getModuleContextMailboxInfo());
        const hasIRM = getHasIRM(rowKey, tableView);
        haveIRM.push(hasIRM);
    }

    return {
        itemType,
        tableViewId: tableView.id,
        tableListViewType: tableView.tableQuery.listViewType,
        rowKeys: selectedRowKeys,
        subjects,
        latestItemIds,
        mailboxInfos,
        sizes,
        haveIRM,
        isCopy,
        // We need to pass the single mailboxInfo as itemData
        // because canDrop does not have all data related to MailListRowDragData type
        itemData: {
            mailboxInfo: getUniqueMailboxInfoOrDefault(getModuleContextMailboxInfo(), mailboxInfos),
        },
    };
}
